import { Action, LOGIN, LOGOUT, REFRESH_TOKEN } from './actions';

type State = {
  token: string | null;
  authed: boolean;
};

const initial = {
  token: null,
  authed: false
};

export default (state: State = initial, action: Action): State => {
  switch (action.type) {
    case REFRESH_TOKEN:
    case LOGIN:
      return {
        token: action.payload,
        authed: true
      };

    case LOGOUT:
      return initial;

    default:
      return state;
  }
};
